var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFeaturesMovie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6625 25.5251H7.7625C3.8125 25.5251 2.5 22.9001 2.5 20.2626V9.7376C2.5 5.7876 3.8125 4.4751 7.7625 4.4751H15.6625C19.6125 4.4751 20.925 5.7876 20.925 9.7376V20.2626C20.925 24.2126 19.6 25.5251 15.6625 25.5251Z",
    fill: "#067FE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24.4 21.3749L20.925 18.9374V11.0499L24.4 8.61242C26.1 7.42492 27.5 8.14992 27.5 10.2374V19.7624C27.5 21.8499 26.1 22.5749 24.4 21.3749Z",
    fill: "#067FE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.375 13.75C15.4105 13.75 16.25 12.9105 16.25 11.875C16.25 10.8395 15.4105 10 14.375 10C13.3395 10 12.5 10.8395 12.5 11.875C12.5 12.9105 13.3395 13.75 14.375 13.75Z",
    fill: "#067FE5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFeaturesMovie);
export default __webpack_public_path__ + "static/media/icon-features-movie.8984cc70b1632f3959022108ed2030a1.svg";
export { ForwardRef as ReactComponent };